import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { useConstructionExtensions } from "@/hooks";
import { ExtensionType } from "@/models/constructionExtensions";
import { RootState } from "@/reducers/types";
import { MarkIcon } from "@/sx-layout/common/MarkIcon";
import { useTerm } from "@/sx-layout/hooks";
import { Mark } from "@/sx-layout/models";
import { getCurrentTimeInMinutes, normalizeHexColor, timeStringToMinutes } from "@/sx-layout/utils";

type Props = {
  id: string;
  mark: Mark;
  selected: boolean;
  onClick: () => void;
  style: React.CSSProperties;
};

export const MarkObject: FC<Props> = ({ mark, selected, ...props }) => {
  const layoutDate = useSelector<RootState, Date>((state) => state.plotmap.layoutDate);
  const { isToday } = useTerm(layoutDate);
  const { extension: objectTransparentExtension } = useConstructionExtensions(ExtensionType.PLOTMAP_OBJECT_TRANSPARENT);
  const isOutsideUseHours = useMemo(() => {
    if (!isToday || !objectTransparentExtension) return false;

    const now = getCurrentTimeInMinutes();
    const start = timeStringToMinutes(mark.use_start_hour);
    const end = timeStringToMinutes(mark.use_end_hour);

    return now < start || end < now;
  }, [objectTransparentExtension, isToday, mark.use_start_hour, mark.use_end_hour]);

  return (
    <div {...props} className="relative" style={{ ...props.style, opacity: isOutsideUseHours ? 0.3 : 1 }}>
      <div id={`mark-moveable-${mark.mark_id}`}>
        <MarkIcon
          markTypeId={mark.mark_type_id}
          color={normalizeHexColor(mark.color)}
          selected={selected}
          active={true}
        />
      </div>
    </div>
  );
};
